import React, { useState, useEffect, useCallback } from "react";
import { Container, Box } from "@material-ui/core";
import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Paper,
  FormControlLabel,
  Checkbox,
  IconButton,
  Stepper,
  Step,
  StepLabel,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
  Popover,
  Divider,
  Menu
} from "@material-ui/core";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  Select,
  FormHelperText,
  InputLabel,
  MenuItem,
  FormControl,
  CircularProgress,
  useMediaQuery
} from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

import { Skeleton, Pagination } from "@material-ui/lab";

import Empty from "../../../assets/svg/empty.svg";

import { useSnackbar } from "notistack";

import { useLicenses } from "../hooks/use_hooks";

import OperatorLogo from "./../../../assets/img/operator.jpg";
import {
  BusinessCenter,
  Add,
  FilterList,
  Close,
  Assignment,
  DonutLarge,
  Search,
  Block,
  MoreVert
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";

import { useHistory } from "react-router-dom";

import { makeStyles,useTheme } from "@material-ui/styles";
import { AdminService, Validator, Permissions, TransportService } from "./../../../utils/web_config";

import Format from "date-fns/format";

import axiosRetry from "axios-retry";
const axios = require("axios");
axiosRetry(axios, { retries: 3 });

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: 10,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    borderRadius: 15,
  },
  paper: {
    padding: 15,
  },
  input: {
    display: "none",
  },
  action: {
    borderRadius: 15,
  },
  card: {
    borderRadius: 15,
  },
}));

function getSteps() {
  return ["Operator info", "Additional info", "Finish"];
}

function OperatorsList(props) {
  const classes = useStyles();
  const history = useHistory();
    const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("sm"));


  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();

  const allLicenses = useLicenses();

  const [accountData, setAccountData] = useState({});

  const [addNewOpen, setAddNewOpen] = useState(false);

  const [operators, setOperators] = useState({
    saving: false,
    loadfing: false,
    page: 0,
    pages: 1,
    count: 20,
    per_page: 20,
    data: [],
  });

  const [hasCode, setHasCode] = useState({
    open: false,
    loading: false,
  });

  const [licensesOpen, setLicensesOpen] = useState(false);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
     const [menuOpen, setMenuOpen] = useState(null);


  const [operatorName, setName] = useState({ value: "", error: "" });
  const [operatorEmail, setEmail] = useState({ value: "", error: "" });
  const [operatorPhone, setPhone] = useState({ value: "", error: "" });
  const [operatorAddress, setAddress] = useState({ value: "", error: "" });
  const [operatorShortName, setShortName] = useState({ value: "", error: "" });

  const [operatorWebsite, setWebsite] = useState({ value: "", error: "" });
  const [operatorTin, setTin] = useState({ value: "", error: "" });
  const [operatorFax, setFax] = useState({ value: "", error: "" });
  const [operatorZip, setZip] = useState({ value: "", error: "" });
  const [operatorContractNumber, setContractNumber] = useState({
    value: "",
    error: "",
  });
  const [operatorCotractStart, setCotractStart] = useState({
    value: new Date(),
    error: "",
  });
  const [operatorContractEnd, setContractEnd] = useState({
    value: new Date(),
    error: "",
  });

  const [operatorSettlementBankAccount, setSettlementBankAccount] = useState({
    value: "",
    error: "",
  });

  const [licenses, setLicenses] = useState({})

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  /////////////////////

  useEffect(() => {
    var accountData = new AdminService().accountData;
    setAccountData(accountData);
    getOperators(accountData.token,0,{has:accountData.user_has_allowed_operator,id:accountData.user_id});
  }, []);

  ///////////////

  const onNameChange = (event) => {
    if (event.target.value === "") {
      setName({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_name")
            }
          </Translate>
        ),
      });
    } else {
      var value = event.target.value;

      setName({ value: value, error: "" });
    }
  };
  const onEmailChange = (event) => {
    if (event.target.value === "") {
      setEmail({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_email")
            }
          </Translate>
        ),
      });
    } else {
      var value = event.target.value;
      setEmail({ value, error: "" });
    }
  };
  const onPhoneChange = (event) => {
    if (event.target.value === "") {
      setPhone({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_phone")
            }
          </Translate>
        ),
      });
    } else {
      setPhone({ value: event.target.value, error: "" });
    }
  };
  const onAddressChange = (event) => {
    if (event.target.value === "") {
      setAddress({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_address")
            }
          </Translate>
        ),
      });
    } else {
      setAddress({ value: event.target.value, error: "" });
    }
  };
  const onShortNameChange = (event) => {
    if (event.target.value === "") {
      setShortName({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_short_name")
            }
          </Translate>
        ),
      });
    } else {
      setShortName({ value: event.target.value, error: "" });
    }
  };

  const onWebsiteChange = (event) => {
    if (event.target.value === "") {
      setWebsite({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_website")
            }
          </Translate>
        ),
      });
    } else {
      setWebsite({ value: event.target.value, error: "" });
    }
  };
  const onTinChange = (event) => {
    if (event.target.value === "") {
      setTin({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("operators.forms.hints.operator_tin")}
          </Translate>
        ),
      });
    } else {
      setTin({ value: event.target.value, error: "" });
    }
  };
  const onFaxChange = (event) => {
    if (event.target.value === "") {
      setFax({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("operators.forms.hints.operator_fax")}
          </Translate>
        ),
      });
    } else {
      setFax({ value: event.target.value, error: "" });
    }
  };
  const onZipChange = (event) => {
    if (event.target.value === "") {
      setZip({
        value: "",
        error: (
          <Translate>
            {({ translate }) => translate("operators.forms.hints.operator_zip")}
          </Translate>
        ),
      });
    } else {
      setZip({ value: event.target.value, error: "" });
    }
  };
  const onContractNumberChange = (event) => {
    if (event.target.value === "") {
      setContractNumber({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_contract_number")
            }
          </Translate>
        ),
      });
    } else {
      setContractNumber({ value: event.target.value, error: "" });
    }
  };

  const onSettlementBankAccountChange = (event) => {
    if (event.target.value === "") {
      setSettlementBankAccount({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate(
                "operators.forms.hints.operator_settlement_bank_account"
              )
            }
          </Translate>
        ),
      });
    } else {
      setSettlementBankAccount({ value: event.target.value, error: "" });
    }
  };
  const onCnotractStartChange = (date) => {
    setCotractStart({ value: date, error: "" });
  };
  const onContractEndChange = (date) => {
    setContractEnd({ value: date, error: "" });
  };

  //////////////////////

  const onRegisterClick = () => {
    if (operatorName.value === "") {
      setName({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_name")
            }
          </Translate>
        ),
      });
    } else if (operatorEmail.value === "") {
      setEmail({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_email")
            }
          </Translate>
        ),
      });
    } else if (!new Validator().validEmail(operatorEmail.value)) {
      setEmail({
        value: operatorEmail.value,
        error: (
          <Translate>
            {({ translate }) =>
              translate("users.forms.hints.user_email_invalid")
            }
          </Translate>
        ),
      });
    } else if (operatorPhone.value === "") {
      setPhone({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_phone")
            }
          </Translate>
        ),
      });
    } else if (operatorAddress.value === "") {
      setAddress({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_address")
            }
          </Translate>
        ),
      });
    }
    // else if (operatorShortName.value === "") {
    //   setShortName({
    //     value: "",
    //     error: (
    //       <Translate>
    //         {({ translate }) =>
    //           translate("operators.forms.hints.operator_short_name")
    //         }
    //       </Translate>
    //     ),
    //   });
    // }
    // else if (operatorWebsite.value === "") {
    //   setWebsite({
    //     value: "",
    //     error: (
    //       <Translate>
    //         {({ translate }) =>
    //           translate("operators.forms.hints.operator_website")
    //         }
    //       </Translate>
    //     ),
    //   });
    // }
    else {
      setActiveStep(1);
    }

    // if (operatorTin.value === "") {
    //   setTin({
    //     value: "",
    //     error: (
    //       <Translate>
    //         {({ translate }) => translate("operators.forms.hints.operator_tin")}
    //       </Translate>
    //     ),
    //   });
    // } else if (operatorFax.value === "") {
    //   setFax({
    //     value: "",
    //     error: (
    //       <Translate>
    //         {({ translate }) => translate("operators.forms.hints.operator_fax")}
    //       </Translate>
    //     ),
    //   });
    // } else if (operatorZip.value === "") {
    //   setZip({
    //     value: "",
    //     error: (
    //       <Translate>
    //         {({ translate }) => translate("operators.forms.hints.operator_zip")}
    //       </Translate>
    //     ),
    //   });
    // }
    // if (operatorContractNumber.value === "") {
    //   setContractNumber({
    //     value: "",
    //     error: (
    //       <Translate>
    //         {({ translate }) =>
    //           translate("operators.forms.hints.operator_contract_number")
    //         }
    //       </Translate>
    //     ),
    //   });
    // }
    if (operatorSettlementBankAccount.value === "") {
      setSettlementBankAccount({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate(
                "operators.forms.hints.operator_settlement_bank_account"
              )
            }
          </Translate>
        ),
      });
    } else if (operatorCotractStart.value === "") {
      setCotractStart({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_contract_start")
            }
          </Translate>
        ),
      });
    } else if (operatorContractEnd.value === "") {
      setContractEnd({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operators.forms.hints.operator_contract_end")
            }
          </Translate>
        ),
      });
    } else {
      setActiveStep(2);
      if (activeStep === 2) {
        createOp();
      }
    }
  };

  ///////////////////////////////

  const clearOrgForm = () => {
    setContractEnd({ value: "", error: "" });
    setCotractStart({ value: "", error: "" });
    setContractNumber({ value: "", error: "" });
    setEmail({ value: "", error: "" });
    setFax({ value: "", error: "" });
    setAddress({ value: "", error: "" });
    setName({ value: "", error: "" });
    setPhone({ value: "", error: "" });
    setShortName({ value: "", error: "" });
    setTin({ value: "", error: "" });
    setWebsite({ value: "", error: "" });
    setZip({ value: "", error: "" });
    setSettlementBankAccount({ value: "", error: "" });
  };

  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };

  const createOp = () => {
    const createInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );
    setOperators({ ...operators, saving: true });

    const data = {
      booking_limit: 0,
      contract_end_date: Format(operatorContractEnd.value, [
        "yyyy-MM-dd HH:mm:ss",
      ]),
      contract_number: operatorContractNumber.value,
      contract_start_date: Format(operatorCotractStart.value, [
        "yyyy-MM-dd HH:mm:ss",
      ]),
      email: operatorEmail.value,
      fax_number: operatorFax.value,
      full_address: operatorAddress.value,
      name: operatorName.value,
      organization_type: "OPERATOR",
      phone_number: operatorPhone.value,
      registration_date: Format(new Date(), ["yyyy-MM-dd HH:mm:ss"]),
      short_name: operatorShortName.value,
      tin: operatorTin.value,
      website: operatorWebsite.value,
      zip_number: operatorZip.value,
      settlement_bank_account: operatorSettlementBankAccount.value,
      settlement_bank_account_name: "",
      settlement_bank_code: ""
    };

    console.log("Creating operator .....");

    createInstance
      .post(new AdminService().CREATE_ORGANIZATION, data)
      .then(function (response) {
        setOperators({ ...operators, saving: false });

        const d = response.data;

        var ops = operators.data;
        ops.unshift(d.data);
        setOperators({ ...operators, data: ops });
        clearOrgForm();

        notify("success", response.data.message);

        setAddNewOpen(false);
      })
      .catch(function (error) {
        setOperators({ ...operators, saving: false });

        var e = error.message;
        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  ////////////

  const getOperators = (token, p = 0,has) => {
    const usersInstance = axios.create(new AdminService().getHeaders(token));
    setOperators({ ...operators, loading: true, page: p });

    var url=has?.has?new AdminService().GET_USER_ALLOWED_OPERATORS +
    has?.id +
    "?page=" +
    p +
    "&size=" +
    operators.per_page:new AdminService().GET_ORGANIZATION_BY_TYPE +
    "OPERATOR" +
    "?page=" +
    p +
    "&size=" +
    operators.per_page
    usersInstance
      .get(url)
      .then(function (response) {
        setOperators({ ...operators, loading: false });

        const d = response.data;

        //console.log(d)
        var ops=[]
        d.data.map((o)=>{

          ops.push(o.organization==null?o:o.organization)
        })

        setOperators({
          ...operators,
          data: ops,
          page: d.current_page,
          count: d.total_items,
          pages: d.total_pages,
        });
      })
      .catch(function (error) {
        setOperators({ ...operators, loading: false });

        var e = error.message;
        if (error.response) {
          e = error.response.data.message;
        }

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };


  const openOperator = (id, dat) => {

    history.push("/centrika/op/view", dat)
  };

  const parseRoutes = (json) => {

    try {
      var a = JSON.parse(json);
      return a
    } catch (e) {
      return []

    }
  }



            //////////////////////////////////

            const linkOrgAccount= () => {
              const createInstance = axios.create(
                new AdminService().getHeaders(accountData.token)
              );
          
              setHasCode({...hasCode,loading:true});
       
              createInstance
                .get(new AdminService().LINK_ORGANIZATION_ACCOUNT+hasCode.id)
                .then(function (response) {
                  setHasCode({open:false,loading:false});
                  var d = response.data;
          
                  getOperators(accountData.token, 0,{has:accountData.user_has_allowed_operator,id:accountData.user_id});
                  notify("success", d.message);
        
                })
                .catch(function (error) {
                  setHasCode({open:false,loading:false});
                  var e = error.message;
          
                  if (error.response) {
                    e = error.response.data.message;
                  }
                  notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
                });
            };
      
  ////////////////
  

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div className={classes.root}>


                             {/* //////////////////////// */}

    <Dialog
        open={hasCode.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth='sm'
        fullWidth
        onClose={()=>setHasCode({...hasCode,open:false})}
      >
        <DialogTitle id="alert-dialog-title">{"Agent account"}</DialogTitle>
        <DialogContent>
        <Box
              mb={1}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
            <Typography color="textSecondary" align="center">
              This agent doesn't have an account yet, click the button to link the agent account.
            </Typography>
          </Box>

        </DialogContent>
        <DialogActions>
          <Button 
           variant='outlined'
          onClick={() => {
            setHasCode({...hasCode,open:false})
            
          }} color="primary">
            Cancel
          </Button>
          <Button 
          variant='contained'
          disableElevation
          disabled={hasCode.loading}
          onClick={() => {
           linkOrgAccount()
          }} color="primary" autoFocus>
            {hasCode.loading ? <CircularProgress size={23} /> : "Link account"}
          </Button>
        </DialogActions>
      </Dialog>

        {/* New operator dialog */}


        <Dialog
          open={addNewOpen}
          maxWidth="sm"
          fullWidth
          onClose={() => setAddNewOpen(false)}
        >
          <DialogTitle id="new-op">
            <Translate id="operators.forms.dialog_title" />
          </DialogTitle>
          <DialogContent>
            {/* <Box mt={1} mb={1}>
            <LinearProgress variant="determinate" value={40} />
          </Box> */}

            <Box width={1}>
              <Stepper
                activeStep={activeStep}
                alternativeLabel
                style={{ padding: 0 }}
              >
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
              <div>
                {activeStep === steps.length ? (
                  <div>
                    <Typography className={classes.instructions}>
                      All steps completed
                    </Typography>
                    <Button>Reset</Button>
                  </div>
                ) : (
                    <div>
                      {activeStep == 0 ? (
                        <Box>
                          <Box mt={2}>
                            <Translate>
                              {({ translate }) => (
                                <TextField
                                  size="small"
                                  variant="outlined"
                                  color="primary"
                                  type="text"
                                  value={operatorName.value}
                                  placeholder={translate(
                                    "operators.forms.hints.operator_name"
                                  )}
                                  label={
                                    <Translate id="operators.forms.labels.operator_name" />
                                  }
                                  fullWidth
                                  onChange={onNameChange}
                                  helperText={operatorName.error}
                                  error={operatorName.error !== ""}
                                />
                              )}
                            </Translate>
                          </Box>
                          <Box mt={2}>
                            <Translate>
                              {({ translate }) => (
                                <TextField
                                  size="small"
                                  variant="outlined"
                                  color="primary"
                                  type="text"
                                  value={operatorEmail.value}
                                  placeholder={translate(
                                    "operators.forms.hints.operator_email"
                                  )}
                                  label={
                                    <Translate id="operators.forms.labels.operator_email" />
                                  }
                                  fullWidth
                                  onChange={onEmailChange}
                                  helperText={operatorEmail.error}
                                  error={operatorEmail.error !== ""}
                                />
                              )}
                            </Translate>
                          </Box>
                          <Box mt={2}>
                            <Translate>
                              {({ translate }) => (
                                <TextField
                                  size="small"
                                  variant="outlined"
                                  color="primary"
                                  type="text"
                                  value={operatorPhone.value}
                                  placeholder={translate(
                                    "operators.forms.hints.operator_phone"
                                  )}
                                  label={
                                    <Translate id="operators.forms.labels.operator_phone" />
                                  }
                                  fullWidth
                                  onChange={onPhoneChange}
                                  helperText={operatorPhone.error}
                                  error={operatorPhone.error !== ""}
                                />
                              )}
                            </Translate>
                          </Box>
                          <Box mt={2}>
                            <Translate>
                              {({ translate }) => (
                                <TextField
                                  size="small"
                                  variant="outlined"
                                  color="primary"
                                  type="text"
                                  value={operatorAddress.value}
                                  placeholder={translate(
                                    "operators.forms.hints.operator_address"
                                  )}
                                  label={
                                    <Translate id="operators.forms.labels.operator_address" />
                                  }
                                  fullWidth
                                  onChange={onAddressChange}
                                  helperText={operatorAddress.error}
                                  error={operatorAddress.error !== ""}
                                />
                              )}
                            </Translate>
                          </Box>
                          <Box mt={2}>
                            <Translate>
                              {({ translate }) => (
                                <TextField
                                  size="small"
                                  variant="outlined"
                                  color="primary"
                                  type="text"
                                  value={operatorShortName.value}
                                  placeholder={translate(
                                    "operators.forms.hints.operator_short_name"
                                  )}
                                  label={
                                    <Translate id="operators.forms.labels.operator_short_name" />
                                  }
                                  fullWidth
                                  onChange={onShortNameChange}
                                  helperText={operatorShortName.error}
                                  error={operatorShortName.error !== ""}
                                />
                              )}
                            </Translate>
                          </Box>

                          <Box mt={2}>
                            <Translate>
                              {({ translate }) => (
                                <TextField
                                  size="small"
                                  variant="outlined"
                                  color="primary"
                                  type="text"
                                  value={operatorWebsite.value}
                                  placeholder={translate(
                                    "operators.forms.hints.operator_website"
                                  )}
                                  label={
                                    <Translate id="operators.forms.labels.operator_website" />
                                  }
                                  fullWidth
                                  onChange={onWebsiteChange}
                                  helperText={operatorWebsite.error}
                                  error={operatorWebsite.error !== ""}
                                />
                              )}
                            </Translate>
                          </Box>
                        </Box>
                      ) : activeStep === 1 ? (
                        <Box>
                          <Box mt={2}>
                            <Translate>
                              {({ translate }) => (
                                <TextField
                                  size="small"
                                  variant="outlined"
                                  color="primary"
                                  type="text"
                                  value={operatorTin.value}
                                  placeholder={translate(
                                    "operators.forms.hints.operator_tin"
                                  )}
                                  label={
                                    <Translate id="operators.forms.labels.operator_tin" />
                                  }
                                  fullWidth
                                  onChange={onTinChange}
                                  helperText={operatorTin.error}
                                  error={operatorTin.error !== ""}
                                />
                              )}
                            </Translate>
                          </Box>

                          <Box mt={2}>
                            <Translate>
                              {({ translate }) => (
                                <TextField
                                  size="small"
                                  variant="outlined"
                                  color="primary"
                                  type="text"
                                  value={operatorZip.value}
                                  placeholder={translate(
                                    "operators.forms.hints.operator_zip"
                                  )}
                                  label={
                                    <Translate id="operators.forms.labels.operator_zip" />
                                  }
                                  fullWidth
                                  onChange={onZipChange}
                                  helperText={operatorZip.error}
                                  error={operatorZip.error !== ""}
                                />
                              )}
                            </Translate>
                          </Box>
                          <Box mt={2}>
                            <Translate>
                              {({ translate }) => (
                                <TextField
                                  size="small"
                                  variant="outlined"
                                  color="primary"
                                  type="text"
                                  value={operatorFax.value}
                                  placeholder={translate(
                                    "operators.forms.hints.operator_fax"
                                  )}
                                  label={
                                    <Translate id="operators.forms.labels.operator_fax" />
                                  }
                                  fullWidth
                                  onChange={onFaxChange}
                                  helperText={operatorFax.error}
                                  error={operatorFax.error !== ""}
                                />
                              )}
                            </Translate>
                          </Box>
                          <Box mt={2}>
                            <Translate>
                              {({ translate }) => (
                                <TextField
                                  size="small"
                                  variant="outlined"
                                  color="primary"
                                  type="text"
                                  value={operatorContractNumber.value}
                                  placeholder={translate(
                                    "operators.forms.hints.operator_contract_number"
                                  )}
                                  label={
                                    <Translate id="operators.forms.labels.operator_contract_number" />
                                  }
                                  fullWidth
                                  onChange={onContractNumberChange}
                                  helperText={operatorContractNumber.error}
                                  error={operatorContractNumber.error !== ""}
                                />
                              )}
                            </Translate>
                          </Box>
                          <Box mt={2}>
                            <Translate>
                              {({ translate }) => (
                                <TextField
                                  size="small"
                                  variant="outlined"
                                  color="primary"
                                  type="text"
                                  value={operatorSettlementBankAccount.value}
                                  placeholder={translate(
                                    "operators.forms.hints.operator_settlement_bank_account"
                                  )}
                                  label={
                                    <Translate id="operators.forms.labels.operator_settlement_bank_account" />
                                  }
                                  fullWidth
                                  onChange={onSettlementBankAccountChange}
                                  helperText={operatorSettlementBankAccount.error}
                                  error={
                                    operatorSettlementBankAccount.error !== ""
                                  }
                                />
                              )}
                            </Translate>
                          </Box>
                          <Box mt={2}>
                            <DatePicker
                              fullWidth
                              disableToolbar
                              variant="inline"
                              format="yyyy-MM-dd"
                              margin="dense"
                              autoOk
                              label={
                                <Translate id="operators.forms.labels.operator_contract_start" />
                              }
                              value={operatorCotractStart.value}
                              inputVariant="outlined"
                              onChange={onCnotractStartChange}
                              InputProps={{
                                disableUnderline: true,
                                style: { paddingRight: 0 },
                              }}
                            />
                          </Box>
                          <Box mt={2}>
                            <DatePicker
                              fullWidth
                              disableToolbar
                              variant="inline"
                              format="yyyy-MM-dd"
                              margin="dense"
                              autoOk
                              label={
                                <Translate id="operators.forms.labels.operator_contract_end" />
                              }
                              value={operatorContractEnd.value}
                              inputVariant="outlined"
                              onChange={onContractEndChange}
                              InputProps={{
                                disableUnderline: true,
                                style: { paddingRight: 0 },
                              }}
                            />
                          </Box>
                        </Box>
                      ) : (
                            <Box m={4}>
                              <Typography align="center">
                                <Translate id="operators.forms.dialog_desc" />
                              </Typography>
                            </Box>
                          )}
                    </div>
                  )}
              </div>

              <Box mt={3} />
              <DialogActions>
                <Button
                  variant="outlined"
                  color="primary"
                  disableElevation
                  onClick={() => {
                    activeStep === 0 ? setAddNewOpen(false) : handleBack();
                  }}
                >
                  {activeStep === 0 ? (
                    <Translate id="operators.forms.buttons.cancel" />
                  ) : (
                      <Translate id="operators.forms.buttons.back" />
                    )}
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  disableElevation
                  disabled={operators.saving}
                  onClick={() => {
                    onRegisterClick();
                  }}
                >
                  {operators.saving ? (
                    <CircularProgress size={25} />
                  ) : activeStep === steps.length - 1 ? (
                    <Translate id="operators.forms.buttons.register" />
                  ) : (
                        <Translate id="operators.forms.buttons.continue" />
                      )}
                </Button>
              </DialogActions>
            </Box>
          </DialogContent>
        </Dialog>
        {/* //////////////////////////// */}

        <Dialog
          open={licensesOpen}
          onClose={() => setLicensesOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle id="alert-dialog-title">
            {"All operators licenses"}
          </DialogTitle>
          <DialogContent>
            <>
              {allLicenses.status == "error" ||
                allLicenses.status == "empty" ? (
                  <Box p={5} display="flex" justifyContent="center">
                    {allLicenses.status == "error" ? (
                      <Typography>
                        Error loading licenses, try to refresh
                      </Typography>
                    ) : (
                        <Typography>
                          There are no licenses available yet.
                        </Typography>
                      )}
                  </Box>
                ) : (
                  <List>
                    {allLicenses.status != "loading"
                      ? allLicenses.data.map((lic, i) => (
                        <>
                          {i != 0 && i != allLicenses.data.length && (
                            <Divider variant="middle" />
                          )}
                          <ListItem
                            key={i}
                            dense
                            button

                            onClick={(e) => setLicenses({ acnhor2: e?.currentTarget, selected: lic.routes })}

                          >
                            <ListItemText
                              primary={"Number: " + lic.license_number}
                              secondary={"Expire: " + lic.expiry_date}
                            />
                            <ListItemSecondaryAction>
                              <Typography
                                color={
                                  lic.license_status == "EXPIRED"
                                    ? "error"
                                    : "primary"
                                }
                              >
                                {lic.license_status}
                              </Typography>
                            </ListItemSecondaryAction>
                          </ListItem>
                        </>
                      ))
                      : Array.from(Array(operators.per_page).keys()).map(
                        (item, i) => (
                          <ListItem key={i}>
                            <ListItemText
                              primary={
                                <Skeleton
                                  variant="text"
                                  width={"100%"}
                                  style={{ borderRadius: 7 }}
                                />
                              }
                            />
                          </ListItem>
                        )
                      )}
                  </List>
                )}
            </>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setLicensesOpen(false)} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>


        {/* ////////////////////////////////// */}

        <Popover
          id={"pop-id"}
          open={licenses.acnhor2 != null}
          anchorEl={licenses.acnhor2}
          onClose={() => setLicenses({ ...licenses, acnhor2: null })}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          elevation={4}
        >
          <Box p={2}>
            <Typography>
              Routes assigned to this organization license, you can not change them
          </Typography>
            <Box mt={2}>
              {
                parseRoutes(licenses.selected).length != 0 ? <List dense>
                  {
                    parseRoutes(licenses.selected)?.map((l, i) => <Box p={1} mt={1} ml={6} display='flex' border={1} borderRadius='borderRadius' justifyContent='space-between'>

                      <Typography>{l.origin}</Typography>
                      <Typography color='primary'>To</Typography>
                      <Typography>{l.dest}</Typography>

                    </Box>)
                  }
                </List> : <Box ml={8} mt={2}>  <Typography color='textSecondary'>{"Assigned routes not available"}</Typography></Box>
              }

            </Box>
            <Button
              variant="outlined"
              size="small"
              color="primary"
              className={classes.btn2}
              onClick={() => setLicenses({ ...licenses, acnhor2: null })}
            >
              Close
          </Button>

          </Box>
        </Popover>



        {/* Dialogs ends here */}

        <Box display="flex">
          <Box mr={2}>
            {" "}
            <BusinessCenter color="primary" fontSize="large" />
          </Box>
          <Typography variant="h5" className={classes.title}>
            <b>Operators</b>
          </Typography>
          <IconButton color="primary">
            <Search />
          </IconButton>

          
          {!matches ? (
                <>
                  <IconButton onClick={(e) => setMenuOpen(e.currentTarget)}>
                    <MoreVert />
                  </IconButton>
                  <Menu
                    id="menu-appbar"
                    anchorEl={menuOpen}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    open={menuOpen != null}
                    onClose={() => setMenuOpen(null)}
                  >
                    <MenuItem
                        onClick={() => {
            
          }}
                    >
                     Filter
                    </MenuItem>
                    
               {/* <MenuItem
                   onClick={() => setLicensesOpen(true)}
                    >
                     Operator licenses
                    </MenuItem> */}
                  </Menu>
                </>
              ) : (
                  <Box ml={2} display="flex" height={40}>
            <Button
              className={classes.btn}
              color="primary"
              variant="outlined"
              size="medium"
              startIcon={<FilterList />}
              disableElevation
            >
              Filter
            </Button>
            {/* <Box ml={2} />
            <Button
              className={classes.btn}
              color="primary"
              variant="contained"
              size="medium"
              startIcon={<Assignment />}
              disableElevation
              onClick={() => setLicensesOpen(true)}
            >
              Lisences
            </Button> */}
          </Box>
                )}
       
        </Box>
        <Box mt={3} />

        <Grid container spacing={2}>
          <Permissions permissions='CAN_CREATE_OPERATOR'> <Grid item xs={6} sm={4} md={4} lg={2}>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              flexDirection="column"
            >
              <CardActionArea
                className={classes.action}
                onClick={() => {
                  setAddNewOpen(true);

                }}
              >
                <Box
                  height="150px"
                  width={1}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  flexDirection="column"
                  border={1}
                  borderStyle="dotted"
                  borderRadius="borderRadius"
                  borderColor="grey.300"
                  className={classes.btn2}
                >
                  <Add fontSize="large" />
                </Box>
              </CardActionArea>
              <Box mt={1}>
                <Typography color="inherit">Add new</Typography>
                <Typography color="textSecondary" variant="caption">
                  New operator
                </Typography>
              </Box>
            </Box>
          </Grid></Permissions>

          {operators.data.length == 0 && !operators.loading && (
            <Box
              p={2}
              height={1}
              display="flex"
              alignItems="center"
              flexDirection="column"
              justifyContent="center"
            >
              <Box mt={2}>
                <img src={Empty} alt="Empty data" height={200} />
              </Box>
              <Typography color="textSecondary">
                There are no operators available yet, create one first
              </Typography>
            </Box>
          )}
          {operators.loading
            ? [1, 2, 3, 4, 5].map((o, i) => (
              <Grid item xs={6} sm={4} md={4} lg={2}>
                <Box
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                  borderRadius={15}
                  width={1}
                >
                  <Skeleton
                    variant="rect"
                    height={150}
                    width={"100%"}
                    style={{ borderRadius: 15 }}
                  />

                  <Skeleton
                    variant="text"
                    width={"68%"}
                    style={{ borderRadius: 7 }}
                  />
                </Box>
              </Grid>
            ))
            : operators.data.map((op, i) => (
              <Grid item xs={6} sm={4} md={4} lg={2}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  flexDirection="column"
                >
                  <CardActionArea
                    className={classes.action}
                    onClick={() => {

                      if (op.agent_code == null) {
                        setHasCode({...hasCode, id: op.organization_id,open:true });
                        return;
                      }
                      openOperator(op.organization_id, op)

                    }}
                  >
                    <Paper className={classes.card} elevation={0}>
                      <Box
                        height="150px"
                        width={1}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        flexDirection="column"
                        border={0}
                        borderRadius="borderRadius"
                        borderColor="grey.300"
                      >
                        {op.organization_status == "DISABLED" && (
                          <Box
                            height={1}
                            width={1}
                            p={1}
                            display="flex"
                            justifyContent="flex-end"
                            alignItems="flex-start"
                            style={{ position: "absolute" }}
                          >
                            <Block color="secondary" />
                          </Box>
                        )}
                        <OrgImage id={op.organization_id}/>
                      </Box>
                    </Paper>
                  </CardActionArea>
                  <Box mt={1}>
                    <Typography color="inherit">{op.name}</Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
        </Grid>
        <Box width={1} mt={2} display="flex" justifyContent="center">
          <Pagination
            disabled={operators.loading || operators.pages==null}
            count={operators.pages}
            page={operators.page + 1}
            onChange={(e, v) => {
              getOperators(accountData.token, v - 1,{has:accountData.user_has_allowed_operator,id:accountData.user_id});
            }}
            size="large"
          />
        </Box>
      </div>
    </MuiPickersUtilsProvider>
  );
}


/////////
/////////////////////////////////////////////////////////////////////////////////////

function OrgImage(props) {
  const [organization, setOrganization] = useState({ status: "loading" });
  const id = props?.id;

  useEffect(() => {
    var accountData = new AdminService().accountData;

    if (organization.data == null) {
      getOrganization(accountData.token);
    }
  }, [organization]);

  const getOrganization = (token) => {
    const gInstance = axios.create(new AdminService().getHeaders(token));

    const url = new AdminService().GET_ORGANIZATION_BY_ID + id;

    gInstance
      .get(url)
      .then(function (response) {
        const d = response.data;
        setOrganization({ data: d.data, status: "success" });
      })
      .catch(function (error) {
        if (error.response) {
          if (error?.response?.status == 404) {
            setOrganization({ data: [], status: "empty" });
          } else {
            setOrganization({ data: [], status: "error" });
          }
        } else {
          setOrganization({ data: [], status: "error" });
        }
      });

    ////
  };

  return( <>
  {organization?.data?.logo_file_byte != null ? (
                          <img alt="icon" src={"data:image/jpg;base64," +organization?.data?.logo_file_byte} width={140} />
                        ) : (
                            <BusinessCenter fontSize="large" />
                          )}
  </>)
}

export default withLocalize(OperatorsList);
